import { Component } from "@angular/core";

@Component({
  selector: 'auth-layout',
  templateUrl: './auth-layout.component.html',
  standalone: false
})
export class AuthLayoutComponent { }
